import { useState } from "react";
import plusIcon from "../../../../../assets/images/icon-plus.svg";
import minusIcon from "../../../../../assets/images/icon-minus.svg";

function Accordion({ title, description }) {
    const [isActive, setActive] = useState(false);
    const handleClick = () => setActive(!isActive);
    return (
        <div className="accordion__item">
            <div className="accordion__title-wrapper" onClick={handleClick}>
                <h2 className="accordion__title">{title}</h2>
                <img
                    src={isActive ? minusIcon : plusIcon}
                    style={{ transform: isActive ? 'rotate(180deg)' : 'rotate(0)' }}
                />
            </div>
            <p className={`accordion__description ${isActive ? 'active' : ''}`}>{description}</p>
        </div>
    );
}

export default Accordion;
